import { useMutation } from '@tanstack/react-query';

import cycleEvaluatorSelectionService from './cycleEvaluatorSelectionService';

import type { CycleEvaluatorSelection } from '@/types/cycle-evaluation/CycleEvaluatorSelection';

import { queryClient } from '@/AppWithProviders';
import { CycleEvaluationQueryKey } from '@/constants/QueryKeys';

const useUpdateCycleEvaluatorSelection = () => {
    return useMutation<CycleEvaluatorSelection, Error, CycleEvaluatorSelection>({
        mutationFn: (cycleEvaluationSelection: CycleEvaluatorSelection) =>
            cycleEvaluatorSelectionService.updateCycleEvaluatorSelection(cycleEvaluationSelection),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [CycleEvaluationQueryKey.CYCLE_EVALUATION],
            });
        },
    });
};

export { useUpdateCycleEvaluatorSelection };
